import React, { useContext } from "react";
import { CareRecipient } from "../../../../domain/care_recipient/CareRecipient";
import { CareRecipientListContext } from "../../../provider/CareRecipientListProvider";
import { MobileHidden, MobileOnly } from "../../responsive/ResponsiveComponents";
import { CareRecipientRow } from "./CareRecipientRow";

export const CareRecipientListItem = React.memo(function CareRecipientListItem(props: Props) {
    const { careRecipient } = props;

    const { handleViewReportClicked } = useContext(CareRecipientListContext);

    return (
        <li key={careRecipient.id.value}>
            <MobileHidden>
                <CareRecipientRow careRecipient={careRecipient} />
            </MobileHidden>
            <MobileOnly>
                <div onClick={() => handleViewReportClicked(careRecipient)}>
                    <CareRecipientRow careRecipient={careRecipient} />
                </div>
            </MobileOnly>
        </li>
    );
});

type Props = {
    careRecipient: CareRecipient,
};
